require '../../modules/merchandising_occasions/frontend/web-frontend'
